import JsonManager from './JsonManager';
import CarouselManager from './CarouselManager';
import ImageManager from './ImageManager';

class BannerManager {
  constructor(id, filePath = '') {
    this.id = id;
    this.banners = JsonManager.getBanners(id);
    this.filePath = filePath;
    this.images = new ImageManager(id, filePath);
  }

  getBannerImageManifest() {
    const projects = [];
    for (let i = 0; i < this.banners.length; i += 1) {
      const id = this.banners[i];
      const project = new CarouselManager(id, this.filePath);
      projects.push(project.getCarouselImageManifest()[0]);
    }
    return projects;
  }

  getDefaultImage() {
    return this.images.getDefaultImage();
  }
}

export default BannerManager;



// WEBPACK FOOTER //
// ./src/managers/BannerManager.js